import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export function DoughWithData(props) {
    const {dataWithLabel,handleSegmentClick=()=>{},bgColor=['#008000','#ffd700','#FF0000',]}=props
    const data = {
      labels:[],
        datasets: [
          {
            data:dataWithLabel?.data||[],
            backgroundColor: bgColor||[
              '#008000',
              '#ffd700',
              '#FF0000',
            ],
            borderColor: bgColor||[
              '#008000',
              '#ffd700',
              '#FF0000',
          ],
          borderWidth: 1,
        },
      ],
    };
    
    return(
        
      <Doughnut data={data}
          options={{
            onClick: handleSegmentClick,
            plugins:{
              legend:false,
                title:{
                  display:false
                },
                tooltip:{
                  backgroundColor:'transparent',
                
                 bodyFont:{
                   size:0
                 }
                }
              }
          }}
        />
      
    )
    
    
  }

  export  function DoughWithNoData() {
    const data = {
      labels:[],
        datasets: [
          {
            // label: [' '],
            data:[100],
            backgroundColor: [
              'rgba(220,220,220.5)',
            ],
            borderColor: [
              'rgba(0,255,255)',
          ],
          borderWidth: 0,
        },
      ],
    };
    
    return(
        
      <Doughnut data={data}
          options={{
            plugins:{
              legend:false,
                title:{
                  display:false
                },
                tooltip:{
                  backgroundColor:'transparent',
                
                 bodyFont:{
                   size:0
                 },
                 bodyColor:'transparent'
                }
              }
          }}
        />
      
    )
    
    
  }